// EmptyState — first-run, zero-data, and post-action emptiness all
// route through one component so the visual rhythm matches across
// surfaces. Replaces inline "Nothing logged yet today" strings.

import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { cn } from '../../lib/cn';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  body?: ReactNode;
  action?: ReactNode;
  variant?: 'inset' | 'flat';
  className?: string;
}

export function EmptyState({
  icon,
  title,
  body,
  action,
  variant = 'inset',
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('empty-state', `empty-state-${variant}`, className)}>
      {icon ? (
        <span className="empty-state-icon" aria-hidden="true">
          <Icon icon={icon} size={24} />
        </span>
      ) : null}
      <p className="empty-state-title">{title}</p>
      {body ? <p className="empty-state-body muted text-caption">{body}</p> : null}
      {action ? <div className="empty-state-action">{action}</div> : null}
    </div>
  );
}
